// RecruitLook owns teams, players and rosters — and therefore the coach's view
// of them. RLevents is the organiser's tool plus the registration flow, so every
// coach-facing destination hands over to RecruitLook.
import { supabase } from '@/integrations/supabase/client';

export const RECRUITLOOK_APP_URL = (
  (import.meta.env.VITE_RECRUITLOOK_APP_URL as string | undefined) || 'https://recruitlook.com'
).replace(/\/+$/, '');

export const RL_COACH_DASHBOARD_PATH = '/club-coach-dashboard';

/** Plain (unauthenticated) link — the coach may land on RL's login screen. */
export function recruitlookUrl(next: string = RL_COACH_DASHBOARD_PATH): string {
  return `${RECRUITLOOK_APP_URL}${next.startsWith('/') ? next : `/${next}`}`;
}

/**
 * Resolve a URL that lands the coach on RecruitLook *signed in* when possible.
 * Falls back to the plain URL whenever there is no session or the handoff
 * function can't mint an RL magic link.
 */
export async function resolveRecruitLookHandoffUrl(
  next: string = RL_COACH_DASHBOARD_PATH,
): Promise<string> {
  try {
    const { data } = await supabase.auth.getSession();
    if (!data?.session) return recruitlookUrl(next);

    const { data: result, error } = await supabase.functions.invoke('rl-coach-handoff', {
      body: { next },
    });
    if (error || !(result as any)?.url) return recruitlookUrl(next);
    return (result as any).url as string;
  } catch {
    return recruitlookUrl(next);
  }
}

/** Navigate the browser to RecruitLook, signed in where possible. */
export async function goToRecruitLook(next: string = RL_COACH_DASHBOARD_PATH): Promise<void> {
  const url = await resolveRecruitLookHandoffUrl(next);
  window.location.replace(url);
}
